// Constants.
// -----------------------------------------------------------------------------
export const TOAST_CONTAINER_DIV_PORTAL = 'ui-toast-portals';
export const TOAST_CONTAINER_DIV_CONTENT = 'ui-toast-content';
export const TOAST_DEFAULT_POSITION = 'bottom-right';
export const TOAST_DEFAULT_DURATION_IN_MILLISECONDS = 5000;
//# sourceMappingURL=Toast.constants.js.map